// extracted by mini-css-extract-plugin
export default {"linkText":"src-signer-app-signer-experience-reassign-banner-module__linkText--3NBsP"};